// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/icon-size.css
// module id = 390
// module chunks = 3